import React , { useState , useEffect } from 'react';
import { Link, NavLink, useNavigate} from 'react-router-dom';
import menus from '../../pages/menu';
import './styles.scss';
import config from '../../config';

const Header = (props) => {
    const { activeIndex, user ,setIsShowLogin} = props;
    const navigate = useNavigate();
    const [scroll, setScroll] = useState(false);
        useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 300);
        });
        return () => {
            setScroll({});
        }
    }, []);

    const [menuActive, setMenuActive] = useState(null);

    const handleMenuActive = () => {
        setMenuActive(!menuActive);
      };

    
    const [activeIndex1, setActiveIndex] = useState(null);
    const handleDropdown = (data, index) => {
        if (data.id == 6 && user == null) {
            setIsShowLogin(true);
        }
        else {
            if (data.id == 400) {
                localStorage.setItem('user', null);
                localStorage.setItem('Authorization', null);
                navigate(config.root + '/');
            }
            if (data.namesub && data.namesub.length > 0) {
                if (activeIndex1 > 0) {
                    setActiveIndex(-1);
                }
                else {
                    setActiveIndex(index);
                }
            }
            else {
                setActiveIndex(-1);
            }
        }
    };
    const onMouseEnter = index => {

    };
    const onMouseLeave = index => {

    };
    const backTo = () => {
        navigate(-1);
    }
   
    return (
        <header id="header_main" className="header" >
             <div className="container">
                <div id="site-header-inner">
                    <div className="back-icon mobile-show" onClick={backTo}>
                    </div>
                    <NavLink to={config.root}>
                        <div className="header__logo">
                        </div>
                    </NavLink>
                <nav id="main-nav" className={`main-nav ${menuActive ? 'active' : ''}`} >
                    <ul id="menu-primary-menu" className="menu">

                            {
                                menus.map((data, idx) => (
                                    <li key={data.id} onMouseEnter={() => onMouseEnter(idx)} onMouseLeave={() => onMouseLeave(idx)} onClick={() => handleDropdown(data, idx)}
                                        className={`menu-item ${(data.namesub && (data.id != 6 || user != null)) ? 'menu-item-has-children' : ''} ${activeIndex === idx || activeIndex1 == idx? 'active' : ''}`}
                                    >
                                        {
                                            data.id == 6 && user == null ? (<Link className="menuName">登录/注册</Link>):
                                            (data.links ? <Link className="menuName" to={config.root + data.links}>{data.name}</Link> :
                                                <span className="menuName">{data.name}</span>)
                                        }
                                    {
                                            (data.namesub && (data.id != 6 || user != null)) &&
                                           <ul className="sub-menu">
                                            {
                                                data.namesub.map((submenu) => (
                                                    <li key={submenu.id} className="menu-item ">
                                                        <NavLink className="menuName" to={config.root + submenu.links}
                                                        onClick={() =>handleDropdown(submenu)}>{submenu.sub}</NavLink></li>
                                                ))
                                            }
                                        </ul>
                                    }
                                    
                                </li>
                            ))
                        }
                    </ul>
                </nav>
                <div className={`mobile-button1 ${menuActive ? 'active' : ''}`} onClick={handleMenuActive}><span></span></div>
            </div>
        </div> 
        </header> 
        
    );
}

export default Header;